import React, { Component, Fragment } from 'react';
import './Lesson.module.scss';

import PageTitle from '../../components/UI/PageTitle/PageTitle'
import Button from '../../components/UI/Button/Button'
import ButtonRight from '../../components/UI/ButtonRight/ButtonRight'
import ButtonFullWidth from '../../components/UI/ButtonFullWidth/ButtonFullWidth';
import SideNavigation from 'components/UI/SideNavigation/SideNavigation';
import TopNavigation from 'components/UI/TopNavigation/TopNavigation';
import PageWrapper from 'components/UI/PageWrapper/PageWrapper';
import ModalContainer from 'components/UI/ModalContainer';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faRocket, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import {faMapMarkerCheck } from '@fortawesome/pro-solid-svg-icons';

import {lessonsData} from 'utilities/lessons';

class Lesson extends Component {
    
    constructor() {
        super();

        this.state = {
            modalOpen: false
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    render() {

        let lesson = lessonsData[this.props.match.params.lessonId - 1];

        let steps = lesson.steps;
        let title = lesson.name;

        let step = 1;

        if(this.props.match.params.step) {
            step = this.props.match.params.step;
        }

        let nextLink = `/les/${this.props.match.params.lessonId}/${parseInt(step) + 1}`;
        let previousLink = `/les/${this.props.match.params.lessonId}/${parseInt(step) - 1}`;
        let slug = title.split(" ").join("-").toLowerCase();

        return (
            <Fragment>
                <TopNavigation/>
                <SideNavigation/>
                <PageWrapper>
                    <div styleName='main'>
                        <div styleName='top'>
                            <div styleName='example' style={{backgroundImage: `url(/images/lessons/${slug}/topimage/${step}.svg)`}}>

                            </div>
                            <div styleName='progress-bar'>
                                <div styleName='progress' style={{ width: `${(step / steps.length) * 100}%`}}>
                                </div>
                                {
                                    lesson.checkpoints.map((checkpoint) => {
                                        return <div styleName={`checkpoint ${step >= checkpoint ? 'active' : ''}`} style={{left: `calc(${(checkpoint / steps.length) * 100}% - 16px)`}}><FontAwesomeIcon size='2x' icon={faMapMarkerCheck}/></div>
                                    })
                                }
                            </div>
                        </div>
                        <div styleName='bottom'>
                            <div styleName='title'>
                                <div>
                                    {/* <a styleName='button' href='/lessen'>  Lesoverzicht</a> */}
                                    <Button link='/lessen' text='Lesoverzicht' style={{margin: 0}} icon={<FontAwesomeIcon icon={faChevronLeft}/>}></Button>
                                    <h3>{title}</h3>
                                    <p>stap {step}/{steps.length}</p>
                                </div>
                                <img src='/images/svg/gotoxy.svg'></img>
                            </div>
                            <div styleName='lesson-content'>
                                <div styleName='lesson-text-wrapper'>
                                    <div styleName='lesson-text'>
                                        <h4>
                                            {steps[step - 1].title}
                                        </h4>
                                        <p dangerouslySetInnerHTML={{__html: steps[step - 1].content}}>
                                           
                                        </p>
                                    </div>
                                </div>
                                <div onClick={this.openModal} styleName='lesson-example-scratch' 
                                // style={{backgroundImage: `url(/images/lessons/${slug}/sideimage/${step}.png)`}}
                                >
                                    <img src={`/images/lessons/${slug}/sideimage/${step}.png`} alt=''/>
                                </div>
                            </div>
                            <div styleName='button-wrapper'>
                            
                                <ButtonRight link={step == steps.length ? `/leseinde/${this.props.match.params.lessonId}` : nextLink} text='Volgende'></ButtonRight>
                                
                                {
                                    step > 1 &&
                                    <ButtonRight link={previousLink} text='Vorige'></ButtonRight>
                                }
                                
                            </div>
                        </div>
                    </div>
                </PageWrapper>
                <ModalContainer open={this.state.modalOpen} closeModal={this.closeModal} >
                                <div styleName='lesson-modal'>
                                <img src={`/images/lessons/${slug}/sideimage/${step}.png`} alt=''/>
                                </div>
                    
                </ModalContainer>
            </Fragment>
        );
    }
}

export default Lesson;


// WEBPACK FOOTER //
// ./resources/assets/screens/Lesson/Lesson.jsx